(function($) {
    $(document).ready(function() {

        var $header = $('.header');
        var $listMenu = $header.find('.list-menu');
        var $listMenuLi = $listMenu.find('>ul>li.list-rz');
        var $megaMenu = $header.find('.submenu-design__megamenu');

        addByCoincidence();

        $listMenuLi.on('mouseenter', function() {
            $listMenuLi.attr('data-active', 0);
            if($(this).attr('data-active') == 0) {
                $(this).attr('data-active', 1);
            }
        });

        $megaMenu.on('mouseleave', function() {
            addByCoincidence();
        })

        function addByCoincidence() {
            console.log(addByCoincidence);
            $listMenuLi.attr('data-active', 0);
            if ($listMenuLi.length > 0) {
                $listMenuLi.each(function(index, item) {
                    var $item = $(item);

                    if ($item.attr('data-link') == $item.attr('data-link-from')) {
                        $item.attr('data-active', 1);
                    }
                });
            }
        }
    });
})(jQuery);